// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"631a0926","52":"b6cb6d40","150":"bf6ab28f","364":"65b64d74","447":"d858188f","453":"2e6c55cf","552":"59913f0c","591":"edcf1dd4","599":"cb38266c","730":"8204bab3","753":"9117e798","806":"27ab00be","826":"49b034c5","918":"f9d75602","929":"f313f33e"}[chunkId] + ".chunk.js";
};